import React, {useMemo} from 'react'
import {cx} from '@emotion/css'

import {BoxProps} from '../../../../../types/Box'
import {
  generateBoxCssClasses,
  generateBoxStyles,
  getSplittedProps
} from './helpers'

export const Box: React.FC<BoxProps> = props => {
  const {
    cssProps,
    baseProps: {children, className, hasMirror, style, ...baseProps}
  } = getSplittedProps(props)

  const styles = useMemo(() => generateBoxStyles(cssProps), [cssProps])

  return (
    <div
      {...baseProps}
      className={cx(
        className,
        hasMirror && 'box_hasMirror',
        ...generateBoxCssClasses(cssProps)
      )}
      style={{...style, ...styles}}
    >
      {children}
    </div>
  )
}
